// ============================================================================
// MediaPlaceholder — лёгкая заглушка тяжёлого медиа в ленте (§2.4): плеер
// ещё не смонтирован (вложение далеко от вьюпорта). НИЧЕГО не загружает —
// ни файл, ни волну, ни метаданные; «волна» — ровный скелет (не форма
// записи). Клик по кнопке воспроизведения монтирует настоящий MediaPlayer
// и запускает запись. Габариты близки к плееру — раскладка ленты не скачет.
// ============================================================================

import { Play, Video } from 'lucide-react';

const SKELETON_BARS = Array.from({ length: 42 }, (_, i) => i);

export function MediaPlaceholder({ kind, name, mine, label, onPlay }: {
  kind: 'audio' | 'video';
  name: string;
  mine: boolean;
  /** Подпись вместо имени файла (напр. «Голосовое сообщение»). */
  label?: string;
  onPlay: () => void;
}) {
  const border = mine ? 'border-primary/30' : 'border-border';
  if (kind === 'video') {
    return (
      <button
        type="button"
        onClick={onPlay}
        title="Воспроизвести"
        className={`relative w-full overflow-hidden rounded-xl border shadow-sm bg-muted/50 ${border}`}
      >
        <span className="flex aspect-video w-full items-center justify-center">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground hover:opacity-90">
            <Play className="h-5 w-5" />
          </span>
        </span>
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-black/45 px-2 py-0.5 text-[10px] text-white">
          <Video className="h-3 w-3" /> Видео
        </span>
        {name && (
          <span className="absolute inset-x-2 bottom-2 truncate text-left text-[10px] text-white/85">{name}</span>
        )}
      </button>
    );
  }
  return (
    <div className={`w-full rounded-xl border px-2.5 py-2 ${mine ? 'border-primary/30 bg-primary/5' : 'border-border bg-muted/40'}`}>
      <div className="flex h-10 items-center gap-[2px] animate-pulse" aria-hidden="true">
        {SKELETON_BARS.map((i) => (
          <span key={i} className="h-2.5 flex-1 rounded-full bg-muted-foreground/25" />
        ))}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onPlay}
          title="Воспроизвести"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground hover:opacity-90"
        >
          <Play className="h-4 w-4" />
        </button>
        <span className="min-w-0 flex-1 truncate text-[10px] text-muted-foreground">{label || name || 'Аудио'}</span>
      </div>
    </div>
  );
}
